import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"info-alt","space":"56"}},[_c(VContainer,[_c(VRow,{attrs:{"justify":"space-between"}},[_c(VCol,{attrs:{"cols":"12","md":"5"}},[_c('base-business-info',{attrs:{"title":"Nous sommes à votre écoute"}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('base-contact-form',{attrs:{"title":"ENVOYER VOTRE MESSAGE"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }